import TEMPLATE_URL from "emun.order/modify-order/modify-order.htm";
import controller from "emun.order/modify-order/modify-order.controller";
import open from "webmodals/open";

export default ({
	size = "xl",
	backdrop = "static",
	placement = "center",
	templateUrl = TEMPLATE_URL,
	mode = "multi-add",
	imageSize = "xxs",
	criteria = {},
	title = `Modify Order...`,
	subTitle
}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			title: () => title,
			subTitle: () => subTitle,
			mode: () => mode,
			imageSize: () => imageSize,
			criteria: () => criteria
		}
	}).result;
